import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MotifButton } from '@ey-xd/motif-react';

const Button = ({ title = 'Submit', targetURL = '#' }) => {
  const navigate = useNavigate();

  const redirectToPage = () => {
    navigate(targetURL);
  };

  return <MotifButton onClick={redirectToPage}>{title}</MotifButton>;
};
export default Button;
